import React, { useState } from 'react';
import Login from './components/Login';
import SaisieCourrier from './components/SaisieCourrier';
import DashboardDG from './components/DashboardDG';
import './App.css';

function App() {
  // 1. État de l'utilisateur (null par défaut)
  const [user, setUser] = useState(null);

  // 2. Si aucun utilisateur n'est connecté, on affiche uniquement le Login
  if (!user) {
    return <Login onLogin={(userData) => setUser(userData)} />;
  }

  // 3. Une fois connecté, on affiche l'interface selon le rôle
  // Note : user.nom_complet correspond à la colonne de ta base de données
  return (
    <div className="App">
      <header className="App-header" style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        padding: '10px 20px', 
        backgroundColor: '#282c34', 
        color: 'white',
        alignItems: 'center'
      }}>
        <div>
          <span>Utilisateur : <strong>{user.nom_complet}</strong></span>
          <span style={{ marginLeft: '15px', fontSize: '0.8em', opacity: 0.8 }}>
            Rôle : {user.role}
          </span>
        </div>
        
        <button 
          onClick={() => setUser(null)} 
          style={{
            width: 'auto', 
            padding: '8px 15px', 
            backgroundColor: '#dc3545', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Déconnexion
        </button>
      </header>

      <main className="main-container" style={{ padding: '20px' }}>
        
        {/* Vue pour l'ADMIN_PRINCIPAL (Saisie + Dashboard) */}
        {user.role === 'ADMIN_PRINCIPAL' && (
          <>
            <div className="card" style={{ marginBottom: '20px' }}>
              <SaisieCourrier />
            </div>
            <div className="card">
              <DashboardDG userId={user.id} />
            </div>
          </>
        )}

        {/* Vue pour le DIRECTEUR (Dashboard uniquement) */}
        {user.role === 'DIRECTEUR' && (
          <div className="card">
            <DashboardDG userId={user.id} />
          </div>
        )}

      </main>
    </div>
  );
}

export default App;